export default __webpack_public_path__ + "static/media/coverresize.066292df.png";